import * as Sentry from "@sentry/angular";
import { HttpErrorResponse } from "@angular/common/http";
import { enableProdMode, provideZonelessChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { isExpectedHttpError, normalizeHttpErrorEvent } from "./app/utils/sentry-http-error";

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: "https://47be963b68db4fa88c9907caa4066183@o146990.ingest.sentry.io/5240221",
  enabled: !["development", "qa", "integration"].includes(environment.name),
  environment: environment.name,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost"],
  beforeSend(event, hint) {
    const error = hint?.originalException;
    if (error instanceof HttpErrorResponse) {
      if (isExpectedHttpError(error)) return null;
      return normalizeHttpErrorEvent(event, error);
    }
    return event;
  },
});

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZonelessChangeDetection()] })
  .catch(err => console.error(err));
